import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React from "react";

const NoAccess: React.FC = () => {
  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle>Access Required</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        Sorry, you don't have access to the app.
      </IonContent>
    </IonPage>
  );
};

export default NoAccess;
